<template>
  <div
    class="w-full md:w-48 h-24 max-w-xs px-4 py-4 mt-5 md:mr-4 overflow-hidden transition-shadow duration-300 ease-in-out bg-white rounded-lg shadow-md hover:shadow-xl"
  >
    <h3 class="text-2xl font-semibold text-primary">
      {{ balance | currency(currency) }}
    </h3>
    <p class="text-xs">
      Correspondiente a {{ bankAccountsCount }} {{ bankAccountsCount > 1 ? "cuentas" : "cuenta" }}
    </p>
  </div>
</template>
<script>

export default {
  props: {
    currency: {
      type: String,
      required: true,
    },
    activeBankAccounts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    balance() {
      return this.activeBankAccounts.reduce((acc, account) => (acc + account.availableBalance), 0);
    },
    bankAccountsCount() {
      return this.activeBankAccounts.length;
    },
  },
};
</script>
